import React, { useState, useEffect } from "react"
import { confirmPopup } from "primereact/confirmpopup"
import { LoaderProgressBar } from "../Loaders"

export function ElementLoading({ children, status, parentCall, item }) {
  const [loadingStatus, setLoadingStatus] = useState(false)

  useEffect(() => {
    setLoadingStatus(false)
  }, [status])

  const reject = () => {
    setLoadingStatus(false)
  }

  const accept = (value, item) => {
    setLoadingStatus(true)
    parentCall(value, item).finally(() => {
      setLoadingStatus(false)
    })
  }

  const onChange = (e) => {
    confirmPopup({
      target: e.currentTarget,
      message: "Are you sure you want to proceed?",
      icon: "pi pi-exclamation-triangle",
      accept: () => accept(e.value, item),
      reject: () => reject(),
    })
  }
  const inputElement = React.cloneElement(children, { onChange })
  return (
    <div>
      {!loadingStatus && inputElement}
      {loadingStatus && <LoaderProgressBar />}
    </div>
  )
}
